import(/* webpackMode: "eager" */ "/app/app/[locale]/hotels/error.tsx");
